var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { filterPropertyTypes, } from '@debbie/common/dist/properties';
import { properties as propertiesApi } from '@debbie/cortex/dist/api';
import PlaceholderLoader from '../PlaceholderLoader';
import PropertyCmp from './Property';
import { propertiesKey, useProperties, usePropertyTypes, } from '@debbie/cortex/dist/properties';
import { h } from '@debbie/cortex/dist';
import q from '@debbie/cortex/dist/query';
const Properties = (props) => {
    const lang = useSelector((s) => s.lang);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? filterPropertyTypes(propertyTypesLoadable.data, props.propRef, props.scope, props.scopeId)
        : null;
    const propertiesLoadable = useProperties(props.propRef, props.propRefId, props.scope, props.scopeId);
    const properties = h.hasData(propertiesLoadable)
        ? propertiesLoadable.data
        : null;
    const loading = h.isLoading(propertyTypesLoadable) || h.isLoading(propertiesLoadable);
    const editable = props.editable !== false;
    const updateProperty = (handle, ref, refId, data, type, setLoading, setDone) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const updatedProperty = yield propertiesApi.update({
            handle,
            ref,
            refId,
            data,
            type,
        });
        q.invalidate([propertiesKey(ref, refId, props.scope, props.scopeId)]);
        setLoading(false);
        setDone(true);
        setTimeout(() => {
            setDone(false);
        }, 1000);
        return updatedProperty;
    });
    return (React.createElement(PropertiesStyled, null,
        loading && React.createElement(PlaceholderLoader, null),
        propertyTypes ? (propertyTypes.map((propertyType) => {
            const property = properties === null || properties === void 0 ? void 0 : properties.find((p) => p.handle === propertyType.handle);
            return (React.createElement(PropertyCmp, { editable: editable, key: propertyType.propertyTypeId, propertyType: propertyType, property: property, updateProperty: updateProperty, refId: props.propRefId }));
        })) : (React.createElement(PlaceholderLoader, null))));
};
export default Properties;
const PropertiesStyled = styled.div `
  font-size: 0.75em;
  input,
  select {
    margin-bottom: 0px;
  }
`;
//# sourceMappingURL=Properties.js.map